import { render } from "./OrderItemForm.vue?vue&type=template&id=645143ed"
import script from "./OrderItemForm.vue?vue&type=script&lang=js"
export * from "./OrderItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__